import React from "react";

// Two sparse-data cases, decided from the trend array itself rather than a
// caller-supplied flag — every chart on the page shares the same trend data,
// so there's one source of truth for "is there enough here to be worth
// reading." Returns null when there's enough activity that the chart should
// just render normally.
function classifySparseness(trend) {
  const activeDays = trend.filter((d) => d.prs_opened > 0 || d.prs_resolved > 0).length;
  if (activeDays === 0) return "empty";
  if (activeDays < 3) return "limited";
  return null;
}

function ChartEmptyState({ trend, firstRecordedDate }) {
  const variant = classifySparseness(trend);
  if (!variant) return null;

  const message =
    variant === "empty"
      ? firstRecordedDate
        ? `No activity recorded yet in this range. Analytics accumulate from ${firstRecordedDate} forward.`
        : "No activity recorded yet. Once a PR opens, it'll show up here."
      : "Limited history so far — trends become meaningful after about a week of activity.";

  return (
    <div className="text-xs text-rf-text-muted bg-rf-bg-tertiary/40 border border-rf-border rounded-lg px-3 py-2 mb-3">
      {message}
    </div>
  );
}

export default ChartEmptyState;
